import { searchActions } from "./reducers";
import * as actionsFile from "./thunks";

export const actions = {
    ...searchActions,
    ...actionsFile
};

export * as selectors from "./selectors";
